import { apiGet } from '~/utils/api'

export interface FaqCategoryItem {
  id: string
  name: string
  slug: string
  faqCount: number
}

export interface FaqItem {
  id: string
  question: string
  answer: string
  categorySlug: string
}

/**
 * 前台 FAQ API
 */
export function useFaqAPI() {
  const { locale } = useI18n()

  async function fetchCategories(): Promise<FaqCategoryItem[]> {
    return await apiGet<FaqCategoryItem[]>(`/api/app/v1/faq/categories?locale=${locale.value}`)
  }

  async function fetchFaqs(options?: { category?: string; limit?: number }): Promise<FaqItem[]> {
    const params = new URLSearchParams({ locale: locale.value })
    if (options?.category) params.set('category', options.category)
    if (options?.limit) params.set('limit', String(options.limit))
    return await apiGet<FaqItem[]>(`/api/app/v1/faq?${params}`)
  }

  return {
    fetchCategories,
    fetchFaqs,
  }
}
